import logo from '@/assets/images/logo/send-box-logo-withe.png';

const WhiteLogo = () => {
    return <img src={logo} alt="SendBox Logo" />;
};

export default WhiteLogo;

